import React from "react";
import PropTypes from "prop-types";
import CRLandingScreen from "./CRLandingScreen";

import './LandingScreen.css';

const LandingScreen = props => {

  const { transitionOut, delay, sounds } = props;

  window.setTimeout(()=>{
    // transitionOut();
  }, (delay || 0) + 3000)

  const onPlayClick = () => {
    transitionOut();
  }

  return (
    <div className="landing-screen">
      <CRLandingScreen 
        transitionOut={transitionOut}
        sounds={sounds}
      />
      <a onClick={onPlayClick}>Play</a>
    </div>
  );
};

LandingScreen.propTypes = {
  transitionOut: PropTypes.func.isRequired,
  delay: PropTypes.number
};

export default LandingScreen;



// WEBPACK FOOTER //
// ./src/components/LandingScreen.jsx